module.exports = __webpack_public_path__ + "media/images/vp/icon.submenu.volonters.black-060010da46c61c3624e22bb8ccecc4c3.svg";